const COLORS = {
    zillow: {
        primary: '#1b5098',
        secondary: '#53dbe4',
        tertiary: '#F2A619',
        quaternary: '#63E37D',
    },
    trulia: {
        primary: '#e13009',
        secondary: '#20c063',
        tertiary: '#F2A619',
    },
    hotpads: {
        primary: '#405474',
        secondary: '#35cdb8',
        tertiary: '#F2A619',
    },
};

const GRAPH_TABS = {
    AVERAGE: 'average',
    TOTAL: 'total',
    DEFAULT: 'default',
};

const GRAPH_DATA_TYPES = {
    VIEWS: 'Views',
    LEADS: 'Contacts',
    CLICKS: 'Website Referrals',
    PROPERTIES: 'Listings',
    RATING: 'Rating',
    REVIEWS: 'Reviews',
    CORE_PRODUCTS: 'Rent Connect',
    BOOST: 'Boost',
    ROCKETSHIP: 'Zillow Feed Connect™',
    SINGLE_FAMILY_LEGACY: 'Pay Per Listing',
    LEASE_CONNECT: 'Lease Connect',
};

const GRAPHS = {
    VIEW: {
        average: {
            TITLE_PREFIX: 'Average page views',
            TAB_INDEX: 0,
            DATA_TYPE: 'average',
        },
        total: {
            TITLE_PREFIX: 'Total page views',
            TAB_INDEX: 1,
            DATA_TYPE: 'total',
        },
        default: {
            TITLE_PREFIX: 'Page views',
            TAB_INDEX: 0,
            DATA_TYPE: 'total',
        },
    },
    LEAD_CLICK: {
        average: {
            TITLE_PREFIX: 'Average contacts and website referrals',
            TAB_INDEX: 0,
            DATA_TYPE: 'average',
        },
        total: {
            TITLE_PREFIX: 'Total contacts and website referrals',
            TAB_INDEX: 1,
            DATA_TYPE: 'total',
        },
        default: {
            TITLE_PREFIX: 'Contacts and website referrals',
            TAB_INDEX: 0,
            DATA_TYPE: 'total',
        },
    },
    PROPERTY: {
        default: {
            TITLE_PREFIX: 'Active listings',
            DATA_TYPE: 'total',
            TAB_INDEX: 0,
        },
    },
    REVIEW: {
        average: {
            TITLE_PREFIX: 'Average ratings',
            DATA_TYPE: 'average',
            DATA_KEY: 'Rating',
            TAB_INDEX: 0,
        },
        total: {
            TITLE_PREFIX: 'Total reviews',
            DATA_TYPE: 'total',
            DATA_KEY: 'Reviews',
            TAB_INDEX: 1,
        },
    },
    INVOICE: {
        default: {
            TITLE_PREFIX: 'Amount spent',
            DATA_TYPE: 'total',
            TAB_INDEX: 0,
        },
    },
};

const GraphConstants = {
    COLORS,
    GRAPHS,
    GRAPH_TABS,
    GRAPH_DATA_TYPES,
};

export default GraphConstants;
